import { Moment } from 'moment-timezone';

/**
 * Returns a date with its local time changed to the given minutes.
 * On most days, this is the same as that many minutes after local midnight, but may
 * differ if the time offset of the date's zone changes during that day.
 */
export function setLocalTimeMinutes(
  base: Moment,
  localTimeMinutes: number,
): Moment {
  // Can't use .minute(localTimeMinutes); that yields an incorrect result across offset
  // changes, just like .add(localTimeMinutes, 'minutes') would.
  const localHour = Math.floor(localTimeMinutes / 60);
  const localMinute = localTimeMinutes % 60;
  return base.clone().hour(localHour).minute(localMinute);
}

/**
 * Returns the local time of the given date in minutes.
 * For any date d and minute m, getLocalTimeMinutes(setLocalTimeMinutes(d, m)) === m.
 */
export function getLocalTimeMinutes(d: Moment): number {
  return d.hour() * 60 + d.minute();
}
